var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info_icon_vector_svg__clip0_13351_113873)",
    stroke: "#616161",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 7.333A3.333 3.333 0 104 .666a3.333 3.333 0 000 6.667zM4 5.333V4M4 2.666h.003"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info_icon_vector_svg__clip0_13351_113873"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8v8H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/info_icon_vector.c46232d5.svg";
export { SvgInfoIconVector as ReactComponent };